import { ReferencedEntry } from 'src/@types/contentful';
import { ExternalLink } from 'src/api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { get, getField } from './EntryUtil';

// from https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url/49849482
// with minor edits
export const isUrl = (str: string) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]+)*\\/?' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
};

/**
 * Get Url Parameter from location.search
 */
export const getUrlParameter = (name: string) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const ensureNoTrailingSlash = (path: string | undefined) => {
  if (!path) { return ''; }

  const hasTrailingSlash = !!path.match('/$');

  return hasTrailingSlash ? path.slice(0, -1) : path;
};

/**
 * Get the proper url if entry is string, flattened entry or a plain Contentful entry
 * @param entry The plain Contentful entry, flattened Contentful entry or slug string
 * @returns The proper url/slug
 */
export function getUrlFromFlattenedOrPlainEntry(entry?: string | ReferencedEntry<ExternalLink> | FlatEntry<ExternalLink>) {
  if (typeof entry === 'string') {
    return entry || '';
  }

  const isPlainEntry = !!((entry as ReferencedEntry<ExternalLink>).sys);

  if (isPlainEntry) {
    return getField(entry as ReferencedEntry<ExternalLink>, 'url', '');
  }

  return get(entry as FlatEntry<ExternalLink>, 'url', '');
}
